<template>
  <div class="table-container">
    <table class="styled-table">
      <thead>
        <tr>
          <th>问题类型</th>
          <th>无证作业事故</th>
          <th>劳动仲裁纠纷</th>
          <th class="none">劳务派遣跑路</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(person, index) in people" :key="index">
          <td>{{ person.name }}</td>
          <td>{{ person.money }}</td>
          <td>{{ person.type }}</td>
          <td class="none">{{ person.percentage }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  data() {
    return {
      people: [
        {
          id: 0,
          name: "无证作业事故",
          money: "500万元",
          type: "100亿元（全国）",
          percentage: "70%",
        },
        {
          id: 1,
          name: "劳动仲裁纠纷",
          money: "50万元",
          type: "30亿元（制造业）",
          percentage: "85%",
        },
        {
          id: 2,
          name: "劳务派遣跑路",
          money: "130万元",
          type: "20亿元（建筑业）",
          percentage: "90%",
        },
      ],
    };
  },
};
</script>

<style scoped>
.table-container {
  /* width: 80%; */
  /* margin: 20px auto; */
  border-radius: 24px 24px 24px 24px;
  box-shadow: 0px 1px 32px 0px rgba(37, 102, 155, 0.12);
  overflow: hidden;
}

.styled-table {
  width: 100%;
  border-collapse: collapse;
  /* border: 1px solid #fff; */
}

.styled-table th,
.styled-table td {
  padding: 37px 108px;
  text-align: center;
  border: 1px solid #000;
  border-bottom: none !important;
  border-left: none !important;
}

@media (max-width: 750px) {
  .styled-table th,
  .styled-table td {
    font-size: 30px;
  }
}
.styled-table th {
  background-color: #fff;
  color: #333;
  border-top: none !important;
}

.styled-table tr {
  background-color: #fff;
}
.none {
  border-right: none !important;
}
</style>
